import {EExternalProjectType, EKind, EStampType, IEmployeeVm, ITimeEntryTypeVm} from '../../Data/Data';
import {NavigationService} from '../../Services/NavigationService';
import {EntryQueueService} from '../../Services/EntryQueueService';
import {TimeQueueItem} from '../../Services/TimeQueueItem';
import {TimeEntryDialog} from '../../Models/time-entry-dialog';
import {TimeEntryDataService} from '../../Services/TimeEntryDataService';
import {NotificationService} from '../../Services/NotificationService';
import {ConfirmDialog} from "../../Models/confirm-dialog";
import {TerminalSessionService} from "../../Services/TerminalSessionService";

export class EnterController {
  static controllerId = 'EnterController';
  static $inject = [
    '$stateParams',
    NavigationService.serviceId,
    EntryQueueService.serviceId,
    TimeEntryDataService.serviceId,
    TerminalSessionService.serviceId,
  ];

  person: IEmployeeVm;
  selectedType: ITimeEntryTypeVm;
  timeEntryDialog = new TimeEntryDialog();
  timeEntryKind = EKind.Work;
  confirmDialog = new ConfirmDialog();


  constructor(private params, private nav: NavigationService,
              private queue: EntryQueueService,
              private timeEntryData: TimeEntryDataService,
              private terminalSession: TerminalSessionService) {

    this.person = params.person;
    const init = this.initType();


    if (!this.person || !this.person.defaultProject) {
      this.goBack();
    }

    if (params.confirm === true) {
      init.then(() => this.confirm());
    }
  }

  private async initType() {
    this.selectedType = await this.timeEntryData.getDefault(this.timeEntryKind);
  }

  canSelectType() {
    return this.terminalSession.canSelectType();
  }

  openTimeEntryDialog() {
    this.timeEntryDialog.open(val => {
      console.log(val);
      this.selectedType = val;
    });
  }

  confirm() {

    if (!this.selectedType) {
      return;
    }

    this.queue.enqueue(new TimeQueueItem(this.selectedType.id,
      this.person.defaultProject.externalId, EExternalProjectType.Proj, this.person.id, new Date(), EStampType.Start));

    this.confirmDialog.open('Buchung gesendet', false, 2000).then(() => {
      this.goBack();
      this.terminalSession.logout();
    });
  }

  goBack() {
    this.nav.goToMenu();
  }

}